<template>
  <div class="ticket" :class="getClass">
    <div class="ticket-condition" v-html="getText"></div>
    <div class="ticket-progress">
      <div class="ticket-progress-spend">
        <span class="diamond"></span>
        <span class="ticket-progress-spend-percent">{{ $bus.currentCost }} / {{ getCurrentCostLimit }}</span>
      </div>
      <ProgressComponent :current="$bus.currentCost" :total="getCurrentCostLimit" />
    </div>
    <div class="ticket-bg" :class="getTicketClass" @click="drawDiscount">
      <span class="ticket-bg-mark" v-show="$bus.ticketBgMarkFlag"></span>
    </div>
  </div>
</template>

<script>
import ProgressComponent from './progress'
import { addGA } from '@/utils/assist'

export default {
  components: {
    ProgressComponent
  },
  computed: {
    getTicketClass () {
      return [this.$bus.ticketBgMarkFlag ? 'ticket-bg-achieved' : 'ticket-bg-unachieved']
    },
    getClass () {
      return `ticket-bg-${this.$bus.shopType}`
    },
    getCurrentCostLimit () {
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      return this.$bus.costLimit[index]
    },
    getText () {
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      const target = `${this.$bus.costLimit[index]}<span class="diamond" style="display:inline-block;vertical-align: middle;width: 0.8em;height:0.8em;margin-left: 0.4em;"></span>`
      let currentText = this.$bus.replaceText(this.$bus.transify['FESTA_GEM_TRAGET'], target)
      if (!currentText) {
        currentText = 'FESTA_GEM_TRAGET'
      }
      return `${currentText}<span class="ticket-bg-text-achieved" style="display:inline-block;vertical-align: middle;width: 0.8em;height:0.8em;margin-left: 0.4em;"></span>`
    }
  },
  methods: {
    drawDiscount () {
      addGA('draw-big-discount', 'click')

      if (this.$bus.isFirst) {
        return
      }

      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      // 若用过折扣券
      if (this.$bus.bigDiscount[index] === -1 || this.$bus[`inuse${this.$bus.shopType}`]) {
        return
      }
      // 是否满足消费额度条件
      // NOTE: 刷新的时候是否要处理ticketBgMarkFlag，也就是满足条件但是还未领取
      if (!this.$bus.ticketBgMarkFlag) {
        this.$bus.toast.show = true
        this.$bus.toast.content = this.$bus.transify['FESTA_TOAST_1'] ? this.$bus.transify['FESTA_TOAST_1'] : 'FESTA_TOAST_1'
        return
      }

      this.$bus.discountDialogShow = true
    }
  },
  watch: {
    '$bus.currentCost': {
      handler (current) {
        const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
        if (current >= this.$bus.costLimit[index] && this.$bus.bigDiscount[index] !== -1 && !this.$bus[`inuse${this.$bus.shopType}`]) {
          this.$bus.ticketBgMarkFlag = true
        } else {
          this.$bus.ticketBgMarkFlag = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket {
  @include flexdcjc;
  position: absolute;
  @include px2res(bottom, 180);
  left: 50%;
  transform: translateX(-50%);
  @include px2res(width, 630);
  @include px2res(height, 80);
  @include px2res(padding-right, 121);
  @include px2res(padding-left, 33);
  transition: background-image 0.6s ease-in;

  .ticket-condition {
    @include px2res(font-size, 20);
    font-style: italic;
    white-space: nowrap;
  }

  .ticket-progress {
    @include flexac;
    @include px2res(margin-top, 6);

    .ticket-progress-spend {
      @include flexac;

      .diamond {
        @include px2res(width, 30);
        @include px2res(height, 27);
      }

      .ticket-progress-spend-percent {
        @include px2res(padding-left, 6);
        @include px2res(padding-right, 11);
        @include px2res(font-size, 22);
        font-style: italic;
      }
    }
  }

  .ticket-bg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &.ticket-bg-achieved {
      @include px2res(width, 82);
      @include px2res(height, 80);
      @include px2res(right, 19);
    }

    &.ticket-bg-unachieved {
      @include px2res(width, 44);
      @include px2res(height, 40);
      @include px2res(right, 38);
    }

    .ticket-bg-mark {
      position: absolute;
      @include px2res(top, 14);
      @include px2res(right, 14);
      @include px2res(width, 18);
      @include px2res(height, 18);
      background:linear-gradient(0deg,rgba(3,0,0,0.32),rgba(255,255,255,0.32));
      background-color: #C31414;
      @include px2res(border-width, 1);
      border-style: solid;
      border-color: rgba(135, 28, 28, 1);
      box-shadow: 0 2px 3px 0 rgba(56,56,56,0.18), 0 0 1px 0 rgba(254,213,146,0.78);
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shop/ticket.vue